

<div
  class="container-fluid"
  *ngIf="show"
  [ngClass]="!showTrade ? 'd-flex' : 'justify-content-center'"
>
  <div class="text-center selected">
    {{
    selectedApi == "open" ? "Trade API" : selectedApi == "fix" ? "GTN Fix API" : selectedApi=="backOffice" ? "Backoffice API":""
    }}
  </div>
  <div *ngIf="showOpen" class="d-flex justify-content-center">
    <div>
      <div class="row padding-inline-100" id="api">
        <div class="card max-w border border-light shadow-0 mb-3 col-md">
          <div class="card-header font-bold hoverMTop">Authentication</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="open"
                title="Authentication"
                imgUrl="assets/img/authentication.png"
                *ngIf="showTrade"
                information="Client applications should be authenticated by getting access tokens before accessing the API."
                fragment="fe8796f14143f-authentication"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="open"
                title="Authentication"
                imgUrl="assets/img/authentication.png"
                *ngIf="!showTrade"
                information="Feed user should be authenticated by getting access tokens before accessing the API."
                fragment="5568fcc2e1323-authentication"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Onboarding</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="open"
                title="Customer Registration"
                imgUrl="assets/img/customer-registration.png"
                information="Includes API calls that help to register new customers and validate usernames."
                fragment="6003b4d98d59d-customer-registration"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="open"
                title="Customer Creation"
                imgUrl="assets/img/customer-creation.png"
                information="Includes API calls that help to create new customers."
                fragment="iey29623fejbh-customer-creation"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Trade</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="open"
                title="Trade Management"
                imgUrl="assets/img/trade-management.png"
                information="Includes functionalities related to orders."
                fragment="5b1da3a6175ad-trade-management"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="open"
                title="Trade Streaming"
                imgUrl="assets/img/trade-streaming.png"
                information="Includes trade streaming details."
                fragment="aycggder8ju39-trade-streaming"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
      </div>

      <div class="row padding-inline-100">
        <div
          class="card border max-w border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Manage</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="open"
                title="Customer Reports"
                imgUrl="assets/img/customer-report.png"
                information="Various reports required by the end customers can be obtained here."
                fragment="aa89a80fe56d7-customer-reports"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="open"
                title="Account & Portfolio"
                imgUrl="assets/img/account-portfolio.png"
                information="Cash and portfolio information of the customers can be viewed here."
                fragment="dde65dc0bc53e-account-and-portfolio"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="open"
                title="Customer & Account Management"
                imgUrl="assets/img/customer-account.png"
                information="Includes functionalities related to managing customers and accounts."
                fragment="2df681c7b87bb-customer-and-account-management"
              >
              </app-landing-page-card>
<!--              <div class="collapse" id="collapseManage">-->
              <div [ngClass]="{'collapse': !showAllManageItems}" id="collapseManage">
                <ul class="list-group list-group-light">
                  <app-landing-page-card
                    api="open"
                    title="Master Data"
                    imgUrl="assets/img/master-data.png"
                    information="Information required from the customers such as currency rates can be obtained here."
                    fragment="908a75318b161-master-data"
                  >
                  </app-landing-page-card>
                  <app-landing-page-card
                    api="open"
                    title="Deposit & Withdraw"
                    imgUrl="assets/img/deposit-withdraw.png"
                    information="Includes API calls that help to place withdrawals, deposit requests and check the status of withdrawal"
                    fragment="784eb7dfaa765-deposit-withdraw"
                  >
                  </app-landing-page-card>
                </ul>
              </div>
              <a
                class="view-more"
                data-toggle="collapse"
                href="#collapseManage"
                role="button"
                aria-expanded="false"
                aria-controls="collapseManage"
                data-ripple-color="dark"
                (click)="onManageAllPress($event)"
              >{{ showAllManageItems ? "Hide" : "View all" }}</a
              >
            </ul>
          </div>
        </div>
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Market Data</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="open"
                title="Ticker Details"
                imgUrl="assets/img/ticker-details.png"
                information="Users can search for a text to find their symbols and this text is matched against many properties to provide the best match."
                fragment="ca8b9d43ca806-ticker-details"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="open"
                title="Chart Data"
                imgUrl="assets/img/chart-data.png"
                information="Allows the retrieval of historical data. This service is provided through the following endpoints."
                fragment="94bd115727fec-chart-data"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="open"
                title="Corporate Action Data"
                imgUrl="assets/img/corporate-actions.png"
                information="Allows the retrieval of corporate action data. This service is provided through the following endpoints."
                fragment="p3cdp0z1ntadb-corporate-action-data"
              >
              </app-landing-page-card>

<!--              <div class="collapse" id="collapseMarketData">-->
              <div [ngClass]="{'collapse': !showAllMarketItems}" id="collapseMarketData">

              <ul class="list-group list-group-light">
                  <app-landing-page-card
                    api="open"
                    title="News & Announcement"
                    imgUrl="assets/img/news-announcement.png"
                    information="Includes functionalities related to managing customers and accounts."
                    fragment="aehyeyekkuk06-news-and-announcements"
                  >
                  </app-landing-page-card>
                  <app-landing-page-card
                    api="open"
                    title="Option Chain"
                    imgUrl="assets/img/option-chain.png"
                    information="Includes option chain details."
                    fragment="378yfyj7o53mz-option-chain"
                  >
                  </app-landing-page-card>
                  <app-landing-page-card
                    api="open"
                    title="Market Data Streaming"
                    imgUrl="assets/img/market-streaming.png"
                    information="Includes streaming details."
                    fragment="yh5fcqjesph76-price-streaming"
                  >
                  </app-landing-page-card>
                </ul>
              </div>
              <a
                class="view-more"
                data-toggle="collapse"
                href="#collapseMarketData"
                role="button"
                aria-expanded="false"
                aria-controls="collapseMarketData"
                data-ripple-color="dark"
                (click)="onMarketAllPress($event)"
              >{{ showAllMarketItems ? "Hide" : "View all" }}</a
              >
            </ul>
          </div>
        </div>

        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="!showTrade"
        >
          <div class="card-header font-bold">Market Data</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="open"
                title="Market Data Streaming"
                imgUrl="assets/img/market-streaming.png"
                information="Includes streaming details."
                fragment="yh5fcqjesph76-price-streaming"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="open"
                title="Ticker Details"
                imgUrl="assets/img/ticker-details.png"
                information="Users can search for a text to find their symbols and this text is matched against many properties to provide the best match."
                fragment="ca8b9d43ca806-ticker-details"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="open"
                title="Chart Data"
                imgUrl="assets/img/chart-data.png"
                information="Allows the retrieval of historical data. This service is provided through the following endpoints."
                fragment="94bd115727fec-chart-data"
              >
              </app-landing-page-card>

<!--              <div class="collapse" id="collapseMarketData">-->
              <div [ngClass]="{'collapse': !showAllMarketItems}" id="collapseMarketData">
              <ul class="list-group list-group-light">
                  <app-landing-page-card
                    api="open"
                    title="Option Chain"
                    imgUrl="assets/img/option-chain.png"
                    information="Includes option chain details."
                    fragment="378yfyj7o53mz-option-chain"
                  >
                  </app-landing-page-card>
                </ul>
              </div>
              <a
                class="view-more"
                data-toggle="collapse"
                href="#collapseMarketData"
                role="button"
                aria-expanded="false"
                aria-controls="collapseMarketData"
                data-ripple-color="dark"
                (click)="onMarketAllPress($event)"
              >{{ showAllMarketItems ? "Hide" : "View all" }}</a
              >
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Fix Api -->
  <div *ngIf="showFix" class="d-flex justify-content-center">
    <div>
      <div class="row padding-inline-100" id="api">
        <div class="card max-w border border-light shadow-0 mb-3 col-md">
          <div class="card-header hoverMTop font-bold">Message Formats</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="fix"
                title="Message Formats"
                imgUrl="assets/img/authentication.png"
                *ngIf="showTrade"
                information="Client applications should be authenticated by getting access tokens before accessing the API."
                fragment="api-message-formats"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Administrative Messages</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="fix"
                title="Administrative Messages"
                imgUrl="assets/img/customer-registration.png"
                information="Includes API calls that help to register new customers and validate usernames."
                fragment="api-adm-messages"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Application Messages</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="fix"
                title="Application Messages"
                imgUrl="assets/img/trade-management.png"
                information="Includes functionalities related to orders."
                fragment="api-app-messages"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
      </div>

      <div class="row padding-inline-100">
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Appendix</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="fix"
                title="Appendix"
                imgUrl="assets/img/customer-report.png"
                information="Various reports required by the end customers can be obtained here."
                fragment="api-appendix"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Release Notes</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                title="Release Notes"
                imgUrl="assets/img/ticker-details.png"
                information="Users can search for a text to find their symbols and this text is matched against many properties to provide the best match."
                fragment="ca8b9d43ca806-ticker-details"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- backOffice Api -->

  <div *ngIf="showBackOffice" class="d-flex justify-content-center">
    <div>
      <div class="row padding-inline-100" id="api">
        <div class="card max-w border border-light shadow-0 mb-3 col-md">
          <div class="card-header font-bold hoverMTop">Account Management</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="backOffice"
                title="Investor Account"
                imgUrl="assets/img/authentication.png"
                *ngIf="showTrade"
                information="Client applications should be authenticated by getting access tokens before accessing the API."
                fragment="035e964642eed-create-individual-investor-account"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Cash Account"
                imgUrl="assets/img/authentication.png"
                *ngIf="showTrade"
                information="Feed user should be authenticated by getting access tokens before accessing the API."
                fragment="mkvm95osh1fus-create-cash-account"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Portfolio Account"
                imgUrl="assets/img/authentication.png"
                *ngIf="showTrade"
                information="Feed user should be authenticated by getting access tokens before accessing the API."
                fragment="d4bb62190dc24-create-portfolio-account"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Exchange Account"
                imgUrl="assets/img/authentication.png"
                *ngIf="showTrade"
                information="Feed user should be authenticated by getting access tokens before accessing the API."
                fragment="9ba4a81b08b40-create-exchange-account"
              >
              </app-landing-page-card>
<!--              <div class="collapse" id="collapseManage">-->
              <div [ngClass]="{'collapse': !showAllManageItems}" id="collapseManage">
              <ul class="list-group list-group-light">
                  <app-landing-page-card
                    api="backOffice"
                    title="Bank Account"
                    imgUrl="assets/img/master-data.png"
                    information="Information required from the customers such as currency rates can be obtained here."
                    fragment="25a2c7b2c1bfa-create-bank-account-for-customer"
                  >
                  </app-landing-page-card>
                  <app-landing-page-card
                    api="backOffice"
                    title="Others"
                    imgUrl="assets/img/deposit-withdraw.png"
                    information="Includes API calls that help to place withdrawals, deposit requests and check the status of withdrawal"
                    fragment="clkrjeb14j7p3-get-account-balance"
                  >
                  </app-landing-page-card>
                </ul>
              </div>
              <a
                class="view-more"
                data-toggle="collapse"
                href="#collapseManage"
                role="button"
                aria-expanded="false"
                aria-controls="collapseManage"
                data-ripple-color="dark"
                (click)="onManageAllPress($event)"
              >{{ showAllManageItems ? "Hide" : "View all" }}</a
              >
            </ul>
          </div>
        </div>
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-b">Finance Management</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="backOffice"
                title="Deposit"
                imgUrl="assets/img/customer-registration.png"
                information="Includes API calls that help to register new customers and validate usernames."
                fragment="6b06691fb72bd3-deposit-request"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Withdrawal"
                imgUrl="assets/img/customer-creation.png"
                information="Includes API calls that help to create new customers."
                fragment="352bab75d387a-withdrawal-request"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Other"
                imgUrl="assets/img/customer-creation.png"
                information="Includes API calls that help to create new customers."
                fragment="02ede387ea25a-get-all-cash-balances-for-a-date"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Account and Portfolio</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="backOffice"
                title="Available Cash Balance"
                imgUrl="assets/img/trade-management.png"
                information="Includes functionalities related to orders."
                fragment="f42b9ca29f704-cash-balance-inquiry"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Manual Cash Balance"
                imgUrl="assets/img/trade-streaming.png"
                information="Includes trade streaming details."
                fragment="d256cc9d19749-cash-block"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Manual Cash Block Removal"
                imgUrl="assets/img/trade-streaming.png"
                information="Includes trade streaming details."
                fragment="6b4f182226e6b-cash-block-removal"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Customer Trading Restrictions"
                imgUrl="assets/img/trade-streaming.png"
                information="Includes trade streaming details."
                fragment="91bb800b6ebfb-trading-restrictions"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Add/Remove Symbol wise Buy/Sell Restrictions"
                imgUrl="assets/img/trade-streaming.png"
                information="Includes trade streaming details."
                fragment="4fb385b3840d3-add-remove-symbol-restrictions"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
      </div>

      <div class="row padding-inline-100">
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Trade Management</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="backOffice"
                title="Get Portfolio wise Holdings"
                imgUrl="assets/img/customer-report.png"
                information="Various reports required by the end customers can be obtained here."
                fragment="de62e4fd421ec-get-holdings"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Get All Order Data For a Date"
                imgUrl="assets/img/account-portfolio.png"
                information="Cash and portfolio information of the customers can be viewed here."
                fragment="b6669aea96a5f-get-order-data"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
        <div
          class="card max-w border border-light shadow-0 mb-3 col-md"
          *ngIf="showTrade"
        >
          <div class="card-header font-bold">Master Data</div>
          <div class="card-body">
            <ul class="list-group list-group-light">
              <app-landing-page-card
                api="backOffice"
                title="FX Currency Rate Upload"
                imgUrl="assets/img/ticker-details.png"
                information="Users can search for a text to find their symbols and this text is matched against many properties to provide the best match."
                fragment="8212974a4603c-currency-rate-upload"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Upload Sharia Symbol"
                imgUrl="assets/img/chart-data.png"
                information="Allows the retrieval of historical data. This service is provided through the following endpoints."
                fragment="82eac53bc1ccf-upload-symbol"
              >
              </app-landing-page-card>
              <app-landing-page-card
                api="backOffice"
                title="Get Account Balance"
                imgUrl="assets/img/corporate-actions.png"
                information="Allows the retrieval of corporate action data. This service is provided through the following endpoints."
                fragment="689d4909b7fa4-get-balance"
              >
              </app-landing-page-card>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



